import React, { useRef, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
} from "@chakra-ui/react";
import { footerConfig } from "./footerConfig";
import "./footer.css";

export function TerminosCondicionesComponent({ visible = false, onToggle }) {
  const bodyRef = useRef(null);

  useEffect(() => {
    if (visible && bodyRef.current) {
      bodyRef.current.scrollTop = 0;
    }
  }, [visible]);

  return (
    <Modal isOpen={visible} onClose={onToggle} size="xl" isCentered>
      <ModalOverlay />
      <ModalContent maxH="90vh" display="flex" flexDirection="column">
        <ModalHeader className="footer-modal-title" flexShrink={0}>
          {footerConfig.titulo_terminos}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody
          ref={bodyRef}
          overflowY="auto"
          flex="1"
          minH={0}
          pb={4}
        >
          <div className="footer-modal-content">
            <div className="footer-modal-bar" />
            <p>
              El acceso y uso de este sitio web supone la aceptación plena y sin
              reservas de la totalidad de las condiciones generales de uso que se
              enumeran a continuación. El Hospital Británico de Buenos Aires (en
              adelante “HOSPITAL BRITANICO”) se reserva la facultad de modificar
              total o parcialmente estos términos y condiciones. Te recomendamos
              leer cuidadosamente los términos y condiciones aquí establecidos
              antes de utilizar este sitio web.
            </p>
            <h5>Usuarios</h5>
            <p>
              El HOSPITAL BRITÁNICO te otorgará un usuario para el acceso al sitio
              web mediante el cual podrás acceder a los servicios disponibles. En
              caso de tener hijos menores de edad podrás cargar sus datos
              personales y acceder al sitio web a través de tu usuario para
              gestionar los trámites atinentes a ellos (en adelante, “Grupo
              Familiar”).
            </p>
            <h5>Responsabilidad de los usuarios</h5>
            <p>
              Aceptando estos términos y condiciones te comprometes expresamente a
              hacer uso del sitio web en forma correcta, sin contravenir la
              legislación argentina, la buena fe y el orden público. No podés, ni
              podrás solicitar o permitir a terceros el uso del sitio web para
              acosar, causar daños, publicar material falso, difamatorio u obsceno,
              violar derechos de privacidad o de propiedad, o violar las leyes
              aplicables.
            </p>
            <h5>Propiedad intelectual</h5>
            <p>
              El contenido del sitio web, incluyendo los materiales, documentos,
              bases de datos, diseños, marcas, logotipos, gráficos, etc., son
              propiedad exclusiva del HOSPITAL BRITANICO. Está prohibido modificar,
              copiar, distribuir, transmitir, publicar o explotar el contenido y
              el diseño del sitio web con fines comerciales y/o privados sin
              autorización expresa del HOSPITAL BRITANICO.
            </p>
            <h5>Privacidad de la información personal</h5>
            <p>
              No difundas por ninguna razón tu nombre de usuario y contraseña. Los
              datos e información proporcionados en este sitio web sólo se podrán
              divulgar al grupo de personas que necesiten conocer esa información
              para cumplir con sus responsabilidades. Para mayor seguridad te
              recomendamos no difundar tu nombre de usuario y contraseña a
              terceros, elegir una contraseña segura y cerrar la sesión cuando
              utilices una computadora compartida.
            </p>
            <h5>Disponibilidad</h5>
            <p>
              El HOSPITAL BRITANICO realizará todo esfuerzo para garantizarte la
              disponibilidad y acceso al sitio web. No obstante, aceptarás que
              podrán producirse interrupciones por mantenimiento. Asimismo, el
              HOSPITAL BRITANICO se reserva el derecho de modificar o eliminar el
              contenido, estructura, diseño, servicios y condiciones de acceso
              y/o uso del sitio web, en forma unilateral y sin previo aviso.
            </p>
            <h5>Comunicación</h5>
            <p>
              Toda notificación u otra comunicación que deba efectuarse bajo el
              presente, deberá realizarse por escrito: (i) Al Usuario: al domicilio
              informado o a la cuenta de correo electrónica declarada; (ii) Al
              HOSPITAL BRITANICO: a atencionalpaciente@hbritanico.com.ar o a la
              calle Perdriel N° 74 de la Ciudad Autónoma de Buenos Aires.
            </p>
            <h5>Jurisdicción competente y ley aplicable</h5>
            <p>
              La resolución de cualquier controversia derivada de la interpretación
              y/o cumplimiento de estos términos y condiciones está sujeta a las
              leyes de la República Argentina y a la jurisdicción de los Tribunales
              Ordinarios de la Capital Federal.
            </p>
            <h5>Modificaciones</h5>
            <p>
              El HOSPITAL BRITANICO se reserva el derecho de modificar o eliminar
              en forma unilateral su sitio web y sus condiciones de uso; negar el
              acceso sin aviso previo a usuarios que no cumplan con sus
              obligaciones; y poner término, suspender o interrumpir
              unilateralmente el acceso y uso del sitio web.
            </p>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" onClick={onToggle}>
            Cerrar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
